import React from "react";

import ScrollNavigation from "../../components/ui/ScrollNavigation.jsx";
import SectionAnchor from "../../components/ui/SectionAnchor.jsx";

import HeroSection from "../portfolio-homepage/components/HeroSection.jsx";
import AboutSection from "../portfolio-homepage/components/AboutSection.jsx";
import SkillsSection from "../portfolio-homepage/components/SkillsSection.jsx";
import ProjectsSection from "../portfolio-homepage/components/ProjectsSection.jsx";
import ExperienceSection from "../portfolio-homepage/components/ExperienceSection.jsx";
import TestimonialsSection from "../portfolio-homepage/components/TestimonialsSection.jsx";
import ContactSection from "../portfolio-homepage/components/ContactSection.jsx";
import FooterSection from "../portfolio-homepage/components/FooterSection.jsx";

export default function PortfolioHomepage() {
  return (
    <div className="min-h-screen" style={{ background: "var(--color-background)" }}>
      <ScrollNavigation />

      {/* Hero — no SectionAnchor needed as it fills viewport */}
      <SectionAnchor id="about" className="">
        <HeroSection />
      </SectionAnchor>

      <SectionAnchor id="skills">
        <AboutSection />
      </SectionAnchor>

      <SectionAnchor id="projects">
        <SkillsSection />
      </SectionAnchor>

      <SectionAnchor id="experience">
        <ProjectsSection />
      </SectionAnchor>

      <SectionAnchor id="testimonials">
        <ExperienceSection />
      </SectionAnchor>

      <SectionAnchor id="contact">
        <TestimonialsSection />
      </SectionAnchor>

      <div id="contact-form">
        <ContactSection />
      </div>

      <FooterSection />
    </div>
  );
}